import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/users")({
  staticData: { breadcrumb: { label: "sidebar.users" } },
  component: () => <Outlet />,
});
